import { render, staticRenderFns } from "./MyNavs.vue?vue&type=template&id=3dec7a2c&scoped=true&"
import script from "./MyNavs.vue?vue&type=script&lang=ts&"
export * from "./MyNavs.vue?vue&type=script&lang=ts&"
import style0 from "./MyNavs.vue?vue&type=style&index=0&id=3dec7a2c&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dec7a2c",
  null
  
)

export default component.exports